"use client";

import { c as _c } from "react/compiler-runtime";
import DatePickerModal from "@/components/datePickerModal/DatePickerModal";
import DownloadUrlWidget from "@/components/downloadUrlWidget/DownloadUrlWidget";
import { publicEnv } from "@/config/env";
import type { ApiArtistNameItem } from "@/generated/models/ApiArtistNameItem";
import { getDateFilters } from "@/helpers/Helpers";
import { fetchUrl } from "@/services/6529api";
import { DateIntervalsSelection, GasRoyaltiesCollectionFocus } from "@/types/enums";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import DotLoader from "../dotLoader/DotLoader";
import styles from "./GasRoyalties.module.scss";
interface HeaderProps {
  title: string;
  description?: string | undefined;
  fetching: boolean;
  results_count: number;
  date_selection: DateIntervalsSelection;
  selected_artist: string;
  is_primary: boolean;
  is_custom_blocks: boolean;
  focus: GasRoyaltiesCollectionFocus;
  getUrl: () => string;
  setSelectedArtist: (artist: string) => void;
  setIsPrimary: (isPrimary: boolean) => void;
  setIsCustomBlocks: (iCustomBlocks: boolean) => void;
  setDateSelection: (dateSelection: DateIntervalsSelection) => void;
  setDates: (fromDate: Date, toDate: Date) => void;
  setBlocks: (fromBlock: number, toBlock: number) => void;
}
function getUrlParams(apiPath: string, isPrimary: boolean, isCustomBlocks: boolean, dateSelection: DateIntervalsSelection, collectionFocus?: GasRoyaltiesCollectionFocus, fromDate?: Date, toDate?: Date, fromBlock?: number, toBlock?: number, selectedArtist?: string): string {
  if (!collectionFocus) {
    return "";
  }
  let filters = "";
  if (isPrimary) {
    filters += "&primary=true";
  } else if (isCustomBlocks) {
    if (fromBlock) {
      filters += `&from_block=${fromBlock}`;
    }
    if (toBlock) {
      filters += `&to_block=${toBlock}`;
    }
  } else {
    filters += getDateFilters(dateSelection, fromDate, toDate);
  }
  const collection = collectionFocus === GasRoyaltiesCollectionFocus.MEMELAB ? "memelab" : "memes";
  const artistFilter = selectedArtist ? `&artist=${selectedArtist}` : "";
  return `${publicEnv.API_ENDPOINT}/api/${apiPath}/collection/${collection}?${filters}${artistFilter}`;
}
export function GasRoyaltiesHeader(props) {
  const $ = _c(123);
  const router = useRouter();
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [artists, setArtists] = useState(t0);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showBlockPicker, setShowBlockPicker] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [fromBlock, setFromBlock] = useState();
  const [toBlock, setToBlock] = useState();
  let t1;
  let t2;
  if ($[1] !== props.focus) {
    t1 = () => {
      const path = props.focus === GasRoyaltiesCollectionFocus.MEMES ? "memes" : "memelab";
      fetchUrl(`${publicEnv.API_ENDPOINT}/api/${path}/artists_names`).then(res => {
        setArtists(res);
      });
    };
    t2 = [props.focus];
    $[1] = props.focus;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== fromBlock || $[5] !== fromDate || $[6] !== props.date_selection || $[7] !== props.is_custom_blocks || $[8] !== props.is_primary || $[9] !== toBlock || $[10] !== toDate) {
    t3 = function getDateSelectionLabel() {
      let label = "";
      if (props.is_primary) {
        label = "Primary Sales";
      } else {
        if (props.is_custom_blocks) {
          if (fromBlock) {
            label = "" + `from block: ${fromBlock} `;
          }
          if (toBlock) {
            label = label + `to block: ${toBlock} `;
          }
        } else {
          if (props.date_selection === DateIntervalsSelection.CUSTOM_DATES) {
            if (fromDate) {
              label = "" + `from: ${fromDate.toISOString().slice(0, 10)} `;
            }
            if (toDate) {
              label = label + `to: ${toDate.toISOString().slice(0, 10)}`;
            }
          } else {
            label = "" + `${props.date_selection}`;
          }
        }
      }
      return <span>{label}</span>;
    };
    $[4] = fromBlock;
    $[5] = fromDate;
    $[6] = props.date_selection;
    $[7] = props.is_custom_blocks;
    $[8] = props.is_primary;
    $[9] = toBlock;
    $[10] = toDate;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const getDateSelectionLabel = t3;
  let t4;
  if ($[12] !== fromBlock || $[13] !== fromDate || $[14] !== props.date_selection || $[15] !== props.focus || $[16] !== props.is_custom_blocks || $[17] !== props.is_primary || $[18] !== props.title || $[19] !== toBlock || $[20] !== toDate) {
    t4 = function getFileName() {
      const title = props.title.toLowerCase().replaceAll(" ", "-");
      const focus = props.focus.toLowerCase().replaceAll(" ", "-");
      let filters;
      if (props.is_primary) {
        filters = "primary-sales";
      } else {
        if (props.is_custom_blocks) {
          filters = `blocks_${fromBlock}-${toBlock}`;
        } else {
          if (props.date_selection === DateIntervalsSelection.CUSTOM_DATES) {
            filters = `dates_${fromDate?.toISOString().slice(0, 10)}-${toDate?.toISOString().slice(0, 10)}`;
          } else {
            filters = `${props.date_selection.toLowerCase().replaceAll(" ", "-")}`;
          }
        }
      }
      return `${title}_${focus}_${filters}.csv`;
    };
    $[12] = fromBlock;
    $[13] = fromDate;
    $[14] = props.date_selection;
    $[15] = props.focus;
    $[16] = props.is_custom_blocks;
    $[17] = props.is_primary;
    $[18] = props.title;
    $[19] = toBlock;
    $[20] = toDate;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  const getFileName = t4;
  let t5;
  if ($[22] !== props.fetching) {
    t5 = props.fetching && <DotLoader />;
    $[22] = props.fetching;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== props.title || $[25] !== t5) {
    t6 = <span className="d-flex align-items-center gap-2"><h1>Meme {props.title} {t5}</h1></span>;
    $[24] = props.title;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  const t7 = `font-larger font-bolder font-color-h ${props.focus === GasRoyaltiesCollectionFocus.MEMES ? styles.collectionFocusActive : styles.collectionFocus}`;
  let t8;
  let t9;
  if ($[27] !== pathname || $[28] !== router) {
    t8 = () => {
      router.push(`${pathname}?focus=${GasRoyaltiesCollectionFocus.MEMES}`);
    };
    t9 = e => {
      if (e.key === "Enter" || e.key === " ") {
        router.push(`${pathname}?focus=${GasRoyaltiesCollectionFocus.MEMES}`);
      }
    };
    $[27] = pathname;
    $[28] = router;
    $[29] = t8;
    $[30] = t9;
  } else {
    t8 = $[29];
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t10 = <span className={t7} onClick={t8} onKeyDown={t9} aria-label="The Memes">The Memes</span>;
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  const t11 = `font-larger font-bolder font-color-h ${props.focus === GasRoyaltiesCollectionFocus.MEMELAB ? styles.collectionFocusActive : styles.collectionFocus}`;
  let t12;
  let t13;
  if ($[35] !== pathname || $[36] !== router) {
    t12 = () => router.push(`${pathname}?focus=${GasRoyaltiesCollectionFocus.MEMELAB}`);
    t13 = e_0 => {
      if (e_0.key === "Enter" || e_0.key === " ") {
        router.push(`${pathname}?focus=${GasRoyaltiesCollectionFocus.MEMELAB}`);
      }
    };
    $[35] = pathname;
    $[36] = router;
    $[37] = t12;
    $[38] = t13;
  } else {
    t12 = $[37];
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t11 || $[40] !== t12 || $[41] !== t13) {
    t14 = <span className={t11} onClick={t12} onKeyDown={t13} aria-label="Meme Lab">Meme Lab</span>;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t10 || $[44] !== t14) {
    t15 = <span className="d-flex align-items-center gap-3">{t10}{t14}</span>;
    $[43] = t10;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t15 || $[47] !== t6) {
    t16 = <Row className="d-flex align-items-center"><Col className="d-flex align-items-center justify-content-between">{t6}{t15}</Col></Row>;
    $[46] = t15;
    $[47] = t6;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== props.description) {
    t17 = props.description && <Row className="pt-3"><Col>{props.description}</Col></Row>;
    $[49] = props.description;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== getFileName || $[52] !== props.fetching || $[53] !== props.getUrl || $[54] !== props.results_count) {
    t18 = !props.fetching && props.results_count > 0 && <DownloadUrlWidget preview="Download" name={getFileName()} url={`${props.getUrl()}&download=true`} />;
    $[51] = getFileName;
    $[52] = props.fetching;
    $[53] = props.getUrl;
    $[54] = props.results_count;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t18) {
    t19 = <span>{t18}</span>;
    $[56] = t18;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  const t20 = props.selected_artist || "All";
  let t21;
  if ($[58] !== props.fetching || $[59] !== t20) {
    t21 = <Dropdown.Toggle disabled={props.fetching}>Artist: {t20}</Dropdown.Toggle>;
    $[58] = props.fetching;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== props) {
    t22 = <Dropdown.Item onClick={() => {
      props.setSelectedArtist("");
    }}>All</Dropdown.Item>;
    $[61] = props;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  let t23;
  if ($[63] !== artists || $[64] !== props) {
    let t24;
    if ($[66] !== props) {
      t24 = a => <Dropdown.Item key={`artist-${a.name.replaceAll(" ", "-")}`} onClick={() => {
        props.setSelectedArtist(a.name);
      }}>{a.name}</Dropdown.Item>;
      $[66] = props;
      $[67] = t24;
    } else {
      t24 = $[67];
    }
    t23 = artists.map(t24);
    $[63] = artists;
    $[64] = props;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  let t24;
  if ($[68] !== t22 || $[69] !== t23) {
    t24 = <Dropdown.Menu>{t22}{t23}</Dropdown.Menu>;
    $[68] = t22;
    $[69] = t23;
    $[70] = t24;
  } else {
    t24 = $[70];
  }
  let t25;
  if ($[71] !== t21 || $[72] !== t24) {
    t25 = <Dropdown className={styles.filterDropdown} drop="down">{t21}{t24}</Dropdown>;
    $[71] = t21;
    $[72] = t24;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  const t26 = props.fetching;
  let t27;
  if ($[74] !== getDateSelectionLabel) {
    t27 = getDateSelectionLabel();
    $[74] = getDateSelectionLabel;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  let t28;
  if ($[76] !== props.fetching || $[77] !== t27) {
    t28 = <Dropdown.Toggle disabled={t26}>{t27}</Dropdown.Toggle>;
    $[76] = props.fetching;
    $[77] = t27;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  let t29;
  if ($[79] !== props) {
    t29 = <Dropdown.Item onClick={() => props.setIsPrimary(true)}>Primary Sales</Dropdown.Item>;
    $[79] = props;
    $[80] = t29;
  } else {
    t29 = $[80];
  }
  let t30;
  let t31;
  let t32;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Dropdown.Divider />;
    t31 = <Dropdown.Header>Secondary Sales</Dropdown.Header>;
    t32 = Object.values(DateIntervalsSelection);
    $[81] = t30;
    $[82] = t31;
    $[83] = t32;
  } else {
    t30 = $[81];
    t31 = $[82];
    t32 = $[83];
  }
  let t33;
  if ($[84] !== props) {
    t33 = t32.map(dateSelection => <Dropdown.Item key={dateSelection} onClick={() => {
      if (dateSelection === DateIntervalsSelection.CUSTOM_DATES) {
        setShowDatePicker(true);
      } else {
        props.setDateSelection(dateSelection);
      }
    }}>{dateSelection}</Dropdown.Item>);
    $[84] = props;
    $[85] = t33;
  } else {
    t33 = $[85];
  }
  let t34;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Dropdown.Item onClick={() => {
      setShowBlockPicker(true);
    }}>Custom Blocks</Dropdown.Item>;
    $[86] = t34;
  } else {
    t34 = $[86];
  }
  let t35;
  if ($[87] !== t29 || $[88] !== t33) {
    t35 = <Dropdown.Menu>{t29}{t30}{t31}{t33}{t34}</Dropdown.Menu>;
    $[87] = t29;
    $[88] = t33;
    $[89] = t35;
  } else {
    t35 = $[89];
  }
  let t36;
  if ($[90] !== t28 || $[91] !== t35) {
    t36 = <Dropdown className={styles.filterDropdown} drop="down">{t28}{t35}</Dropdown>;
    $[90] = t28;
    $[91] = t35;
    $[92] = t36;
  } else {
    t36 = $[92];
  }
  let t37;
  if ($[93] !== t25 || $[94] !== t36) {
    t37 = <span className="d-flex align-items-center gap-5">{t25}{t36}</span>;
    $[93] = t25;
    $[94] = t36;
    $[95] = t37;
  } else {
    t37 = $[95];
  }
  let t38;
  if ($[96] !== t19 || $[97] !== t37) {
    t38 = <Row className="pt-3"><Col className="d-flex align-items-center justify-content-between">{t19}{t37}</Col></Row>;
    $[96] = t19;
    $[97] = t37;
    $[98] = t38;
  } else {
    t38 = $[98];
  }
  let t39;
  if ($[99] !== t16 || $[100] !== t17 || $[101] !== t38) {
    t39 = <Container className="pt-4">{t16}{t17}{t38}</Container>;
    $[99] = t16;
    $[100] = t17;
    $[101] = t38;
    $[102] = t39;
  } else {
    t39 = $[102];
  }
  let t40;
  if ($[103] !== props) {
    t40 = (fromDate_0, toDate_0) => {
      setFromDate(fromDate_0);
      setToDate(toDate_0);
      props.setDates(fromDate_0, toDate_0);
    };
    $[103] = props;
    $[104] = t40;
  } else {
    t40 = $[104];
  }
  let t41;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = () => setShowDatePicker(false);
    $[105] = t41;
  } else {
    t41 = $[105];
  }
  let t42;
  if ($[106] !== fromDate || $[107] !== showDatePicker || $[108] !== t40 || $[109] !== toDate) {
    t42 = <DatePickerModal mode="date" show={showDatePicker} initial_from_date={fromDate} initial_to_date={toDate} onApplyDate={t40} onHide={t41} />;
    $[106] = fromDate;
    $[107] = showDatePicker;
    $[108] = t40;
    $[109] = toDate;
    $[110] = t42;
  } else {
    t42 = $[110];
  }
  let t43;
  if ($[111] !== props) {
    t43 = (fromBlock_0, toBlock_0) => {
      setFromBlock(fromBlock_0);
      setToBlock(toBlock_0);
      props.setBlocks(fromBlock_0, toBlock_0);
    };
    $[111] = props;
    $[112] = t43;
  } else {
    t43 = $[112];
  }
  let t44;
  if ($[113] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = () => setShowBlockPicker(false);
    $[113] = t44;
  } else {
    t44 = $[113];
  }
  let t45;
  if ($[114] !== fromBlock || $[115] !== showBlockPicker || $[116] !== t43 || $[117] !== toBlock) {
    t45 = <DatePickerModal mode="block" show={showBlockPicker} initial_from_block={fromBlock} initial_to_block={toBlock} onApplyBlock={t43} onHide={t44} />;
    $[114] = fromBlock;
    $[115] = showBlockPicker;
    $[116] = t43;
    $[117] = toBlock;
    $[118] = t45;
  } else {
    t45 = $[118];
  }
  let t46;
  if ($[119] !== t39 || $[120] !== t42 || $[121] !== t45) {
    t46 = <>{t39}{t42}{t45}</>;
    $[119] = t39;
    $[120] = t42;
    $[121] = t45;
    $[122] = t46;
  } else {
    t46 = $[122];
  }
  return t46;
}
interface TokenImageProps {
  path: string;
  token_id: number;
  name: string;
  thumbnail: string;
  note?: string | undefined;
}
export function GasRoyaltiesTokenImage(props) {
  const $ = _c(26);
  const t0 = `/${props.path}/${props.token_id}`;
  let t1;
  if ($[0] !== props.token_id) {
    t1 = <span>{props.token_id} -</span>;
    $[0] = props.token_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "auto",
      height: "40px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `token-image-${props.token_id}`;
  let t4;
  if ($[3] !== props.name || $[4] !== props.thumbnail || $[5] !== t3) {
    t4 = <Image unoptimized={true} loading="lazy" width={0} height={0} style={t2} src={props.thumbnail} alt={props.name} className={styles.nftImage} data-tooltip-id={t3} />;
    $[3] = props.name;
    $[4] = props.thumbnail;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.note || $[8] !== props.token_id) {
    t5 = props.note && <span><FontAwesomeIcon className={styles.infoIcon} icon={faInfoCircle} data-tooltip-id={`token-info-${props.token_id}`} /></span>;
    $[7] = props.note;
    $[8] = props.token_id;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <span className="d-flex justify-content-center aling-items-center gap-3">{t1}{t4}{t5}</span>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `token-image-${props.token_id}`;
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== props.name || $[16] !== t7) {
    t9 = <Tooltip id={t7} content={props.name} style={t8} />;
    $[15] = props.name;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== props.note || $[19] !== props.token_id) {
    t10 = props.note && <Tooltip id={`token-info-${props.token_id}`} content={props.note} style={{
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    }} />;
    $[18] = props.note;
    $[19] = props.token_id;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t0 || $[22] !== t10 || $[23] !== t6 || $[24] !== t9) {
    t11 = <a href={t0} target="_blank" rel="noopener noreferrer">{t6}{t9}{t10}</a>;
    $[21] = t0;
    $[22] = t10;
    $[23] = t6;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
export function useSharedState() {
  const $ = _c(31);
  const [selectedArtist, setSelectedArtist] = useState("");
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [fromBlock, setFromBlock] = useState();
  const [toBlock, setToBlock] = useState();
  const [showBlockPicker, setShowBlockPicker] = useState(false);
  const [dateSelection, setDateSelection] = useState(DateIntervalsSelection.THIS_MONTH);
  const [isPrimary, setIsPrimary] = useState(false);
  const [isCustomBlocks, setIsCustomBlocks] = useState(false);
  const [collectionFocus, setCollectionFocus] = useState();
  const [fetching, setFetching] = useState(true);
  let t0;
  if ($[0] !== collectionFocus || $[1] !== dateSelection || $[2] !== fromBlock || $[3] !== fromDate || $[4] !== isCustomBlocks || $[5] !== isPrimary || $[6] !== selectedArtist || $[7] !== toBlock || $[8] !== toDate) {
    t0 = function getUrl(type) {
      return getUrlParams(type, isPrimary, isCustomBlocks, dateSelection, collectionFocus, fromDate, toDate, fromBlock, toBlock, selectedArtist);
    };
    $[0] = collectionFocus;
    $[1] = dateSelection;
    $[2] = fromBlock;
    $[3] = fromDate;
    $[4] = isCustomBlocks;
    $[5] = isPrimary;
    $[6] = selectedArtist;
    $[7] = toBlock;
    $[8] = toDate;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  const getUrl = t0;
  let t1;
  if ($[10] !== dateSelection || $[11] !== fetching || $[12] !== isCustomBlocks || $[13] !== isPrimary || $[14] !== selectedArtist) {
    t1 = function getSharedProps() {
      return {
        fetching,
        date_selection: dateSelection,
        selected_artist: selectedArtist,
        is_primary: isPrimary,
        is_custom_blocks: isCustomBlocks,
        setSelectedArtist,
        setIsPrimary,
        setIsCustomBlocks,
        setDates: (fromDate_0, toDate_0) => {
          setFromDate(fromDate_0);
          setToDate(toDate_0);
          setIsPrimary(false);
          setIsCustomBlocks(false);
          setDateSelection(DateIntervalsSelection.CUSTOM_DATES);
        },
        setBlocks: (fromBlock_0, toBlock_0) => {
          setFromBlock(fromBlock_0);
          setToBlock(toBlock_0);
          setIsPrimary(false);
          setIsCustomBlocks(true);
        }
      };
    };
    $[10] = dateSelection;
    $[11] = fetching;
    $[12] = isCustomBlocks;
    $[13] = isPrimary;
    $[14] = selectedArtist;
    $[15] = t1;
  } else {
    t1 = $[15];
  }
  const getSharedProps = t1;
  let t2;
  if ($[16] !== collectionFocus || $[17] !== dateSelection || $[18] !== fetching || $[19] !== fromBlock || $[20] !== fromDate || $[21] !== getSharedProps || $[22] !== getUrl || $[23] !== isCustomBlocks || $[24] !== isPrimary || $[25] !== selectedArtist || $[26] !== showBlockPicker || $[27] !== showDatePicker || $[28] !== toBlock || $[29] !== toDate) {
    t2 = {
      selectedArtist,
      setSelectedArtist,
      fromDate,
      setFromDate,
      toDate,
      setToDate,
      showDatePicker,
      setShowDatePicker,
      dateSelection,
      setDateSelection,
      isPrimary,
      setIsPrimary,
      isCustomBlocks,
      setIsCustomBlocks,
      collectionFocus,
      setCollectionFocus,
      fetching,
      setFetching,
      getUrl,
      getSharedProps,
      showBlockPicker,
      setShowBlockPicker,
      fromBlock,
      setFromBlock,
      toBlock,
      setToBlock
    };
    $[16] = collectionFocus;
    $[17] = dateSelection;
    $[18] = fetching;
    $[19] = fromBlock;
    $[20] = fromDate;
    $[21] = getSharedProps;
    $[22] = getUrl;
    $[23] = isCustomBlocks;
    $[24] = isPrimary;
    $[25] = selectedArtist;
    $[26] = showBlockPicker;
    $[27] = showDatePicker;
    $[28] = toBlock;
    $[29] = toDate;
    $[30] = t2;
  } else {
    t2 = $[30];
  }
  return t2;
}